<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->
  <v-expansion-panel popout class="mt-2" width="100%">
    <v-expansion-panel-header color="#708e92" class="white--text">
      <template v-slot:actions>
        <v-icon color="white"> $expand </v-icon>
      </template>
      Can I file a report on someone’s behalf?
    </v-expansion-panel-header>
    <v-expansion-panel-content class="grey lighten-5">
      <v-row>
        <c-col id="faq-content">
          <v-card elevation="2" tile class="mt-8 mb-4">
            <v-card-text class="black--text">
              The victim of the crime typically must be the reporting party and
              involved in the reporting process. The exceptions to this rule are
              minor children, endangered/vulnerable persons, or situations in
              which a legal guardianship/power of attorney are in place.
            </v-card-text>
          </v-card>
        </c-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<style scoped>
.bcs-expansion-content {
  color: black;
}
.howwrap {
  word-break: break-word;
}
</style>
<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "fd_faq_other",
  mixins: [bus_common],
  data: function () {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    init: function () {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>
